'use client'

import { useCallback } from 'react'
import { useAnalytics } from './useAnalytics'

export interface ProductEventItem {
    item_id: string
    item_name: string
    price?: number
    currency?: string
    quantity?: number
    item_category?: string
    item_variant?: string
}

export function useEcommerce(siteId: string, baseCurrency: string = 'DZD') {
    const { trackEvent } = useAnalytics(siteId)

    const viewItem = useCallback((item: ProductEventItem) => {
        trackEvent('view_item', {
            currency: item.currency || baseCurrency,
            value: item.price,
            items: [item]
        })
    }, [trackEvent])

    const addToCart = useCallback((item: ProductEventItem) => {
        trackEvent('add_to_cart', {
            currency: item.currency || baseCurrency,
            value: (item.price || 0) * (item.quantity || 1),
            items: [item]
        })
    }, [trackEvent])

    const viewCart = useCallback((cartItems: ProductEventItem[], totalValue: number, currency = baseCurrency) => {
        trackEvent('view_cart', {
            currency,
            value: totalValue,
            items: cartItems
        })
    }, [trackEvent])

    const beginCheckout = useCallback((cartItems: ProductEventItem[], totalValue: number, currency = baseCurrency) => {
        trackEvent('begin_checkout', {
            currency,
            value: totalValue,
            items: cartItems
        })
    }, [trackEvent])

    const purchase = useCallback((transactionId: string, cartItems: ProductEventItem[], totalValue: number, currency = baseCurrency) => {
        trackEvent('purchase', {
            transaction_id: transactionId,
            currency,
            value: totalValue,
            items: cartItems
        })
    }, [trackEvent])

    return {
        viewItem,
        addToCart,
        viewCart,
        beginCheckout,
        purchase
    }
}
